export default {
  open: (state) => {
    state.isOpen = true;
  },
  close: (state) => {
    state.isOpen = false;
  },
};
